<template>
    <!-- The one-line status that sits beside a report's Generate button: the
         outcome of the last run, or (when the button is disabled) why it can't run
         yet. Success/error/disabled are mutually exclusive; nothing renders when
         there is nothing to say. Kept as its own tiny component because the same
         message appears in two footer layouts (the in-flow footer and the fixed
         ActionFooter), so it stays in sync. -->
    <span   v-if="successMessage"
            class="flex items-start gap-2 text-green-700">
        <tabler-icon name="check" size-class="mt-0.5 h-4 w-4" :stroke-width="2"></tabler-icon>
        <span>{{ successMessage }}</span>
    </span>

    <span   v-else-if="errorMessages.length > 0"
            class="flex items-start gap-2 text-red-700">
        <tabler-icon name="alertCircle" size-class="mt-0.5 h-4 w-4" :stroke-width="2"></tabler-icon>
        <span>
            <span   v-for="(error, index) in errorMessages"
                    :key="index"
                    class="block">
                {{ error }}
            </span>
        </span>
    </span>

    <span   v-else-if="disabledReason"
            class="text-gray-500">
        {{ disabledReason }}
    </span>
</template>

<script>
import TablerIcon from "@/components/elements/TablerIcon.vue"
export default {
    name: "RunStatusMessage",
    components: {TablerIcon},
    props: {
        // A "your report is on its way" confirmation after a successful run.
        successMessage: {
            type: String,
            default: '',
        },
        // Validation / server errors from the last run attempt.
        errorMessages: {
            type: Array,
            default: () => ([]),
        },
        // Why the Generate button is disabled (e.g. "Select at least one point").
        disabledReason: {
            type: String,
            default: '',
        },
    },
}
</script>
